import Group from "./Group";
import Single from "./Single";

const Summary = {
  Group,
  Single,
};

export default Summary;
